
import { Icon } from 'vant';
import{ref,inject, reactive,watch} from 'vue'
import Vrouter from '@/router';
interface Item{
    type:String,
    data:String
}

interface List{
   timeList:Array<any>,
   dataList:Array<Object>,
   size:number,
   page:number,
   total:number
};


/**
 * menu菜单更多
 * 
*/
interface MenuMore {
   icon:String,
   title:String,
   type:Number,
   url:String,
}
//商品删除和添加选择
enum BTN_HANDEL {
 DELETE = 'delete',
 ADD_GOODS = 'add_goods'
}
interface Does{
   list:Array<String>
};

 function useSeckillHooks(){
     const $http:any = inject('$http')
     const loading = ref(false)
     const finished = ref(false)
     const status_name:any = ref('')
     const demos = ref(0)
     const active = ref(0)
     const seckillList:List = reactive({
       timeList:[],
       dataList:[],
       size:10,
       page:1,
       total :500,
     })
     let flash_sale_time:any = ref('')
     let is_flash_sale_start = ref(false)
     let new_date_time:any = ref(0)
     let flash_sale_times_arr = ref(0)
     let doesList:Does = reactive({list:[]})
     let hour:any = ref();   
     let over_time = ref()
     let havebegun = ref(true)
     let pitch = ref(true)
    


     const onLoad = async (val:String = '')=>{
      loading.value = true
      window.scrollTo(0,0)
      const res = await $http.get_flashsales({
          hour:hour.value ? hour.value :null,
          size:seckillList.size,
          page:seckillList.page,
          total:seckillList.total,
      })
      seckillList.timeList = res.scenes     
    
 
      if(pitch.value){
      
         res.scenes?res.scenes.forEach((e:any,i:number) => {         
            if(e.show == true){
              active.value = i
              console.log('选中.value',active.value);
              
            }
         }):''; 
      }

      if(res.total>0){

          status_name.value = res.scenes[active.value].text
          seckillList.dataList =seckillList.dataList.concat(res.data)        
          let status = res.scenes[active.value].text
          flash_sale_time.value = res.scenes[active.value].start_timestamp
          if(status === 'On Going'){
            is_flash_sale_start.value = false
            new_date_time.value = res.current.timestamp;
            flash_sale_timeout_fn()                                                   
         }else {
            doesList.list= res.scenes[0].hour.split(':')
            doesList.list.push('00')
            havebegun.value = false          
         }
         if(seckillList.dataList.length>=res.total){
            finished.value = true
         }  
         loading.value = false    
         seckillList.page = seckillList.page + 1
          if(res.current_page == 1){
              return;
          }else{
             return true
          }       
      }else {
         finished.value = true;
       }
        
    }
    const flash_sale_timeout_fn = ()=>{
      //秒杀开始毫秒📖
      let gettime = flash_sale_time.value * 1000;
       //增加2小时毫秒数，就是秒杀结束时间
      gettime = gettime + (2 * 60 * 60 * 1000);
       //当前时间毫秒数
      new_date_time.value = parseInt(new_date_time.value) * 1000;
       //剩余毫秒数
        over_time.value = gettime - new_date_time.value;
         if(Number(over_time.value) > 0)  flash_sale_times_arr.value = over_time.value ;
      }
          
    const timingClick = (val:string,index:number)=>{
      seckillList.dataList = [],
      seckillList.page = 1,     
      active.value = index
      window.scrollTo(0,0)
      hour.value = val
      pitch.value = false
      finished.value = false 
      //  onLoad()          
    } 
    
    watch(()=>active.value,(val)=>{
      hour.value =  seckillList.timeList[val].hour
      seckillList.dataList = [],
      seckillList.page = 1,     
      active.value = val
      finished.value = false 
      onLoad()   
   //   timingClick(hour.value,val)
   })
     return {
        seckillList,
        loading,
        finished,
        onLoad,
        timingClick,
        active,
        status_name,
        flash_sale_times_arr,
        doesList,
        havebegun,
        demos
     }
 }

 export {
    useSeckillHooks,
    MenuMore,
    BTN_HANDEL,
 }
